<script>
import IconWrapper from "./IconWrapper.vue";
import IconWatchmanVisibilitySvg from "@/assets/img/icons/IconWatchmanVisibility.svg";

export default {
  name: "IconWatchmanVisibility",
  components: {
    IconWrapper,
  },
  computed: {
    svg() {
      return IconWatchmanVisibilitySvg;
    },
  },
};
</script>

<template>
  <IconWrapper v-html="svg" class="IconWatchmanVisibility" />
</template>
